module.exports = __webpack_public_path__ + "20f6c6b1382410d1792404cc1e5cc0fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/mouse-ears-s.png
// module id = 2928
// module chunks = 0